export const FEEDBACK_TAGS = [
  "DEFINE",
  "CONFUSING",
  "INSIDER",
  "CUTE",
  "TONE",
  "MISSING",
  "VISUAL",
  "LONG",
  "ORDER",
  "PROMISE",
  "CONTRADICTS",
  "FACT",
] as const;

export type FeedbackTag = (typeof FEEDBACK_TAGS)[number];

const SUGGESTION_TAGS: string[] = ["VISUAL", "MISSING", "LONG", "ORDER"];

export function categoryForTag(tag: string): "confusion" | "suggestion" {
  return SUGGESTION_TAGS.includes(tag) ? "suggestion" : "confusion";
}

export function kindForTag(tag: string): string {
  if (tag === "DEFINE") return "missing_term";
  if (tag === "FACT") return "wrong_or_outdated";
  return "confusing";
}

export function tagNoteRequired(tag: string): boolean {
  return tag === "VISUAL" || tag === "CONTRADICTS";
}

export function tagNotePlaceholder(tag: string | null): string {
  if (tag === "VISUAL") return "Say what the picture would show";
  if (tag === "CONTRADICTS") return "Give the other page id";
  return "A few words (optional)";
}
